import {Component, Input} from '@angular/core';
import {MessageType} from '../../../../libs/botato-angular-lib/botato-chat-message/message-type/message-type';
import {MessageViewModel} from '../../../../libs/botato-angular-lib/viewmodel/MessageViewModel';

@Component({
    templateUrl: './negative-text.component.html',
    styleUrls: ['./negative-text.component.scss']
})
export class NegativeTextComponent implements MessageType{
    public static TYPE = 'NegativeTextItem';

    @Input()
    public message!: MessageViewModel;
}
